import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3z"
}), 'AccountTree');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AccountTree.js
// module id = 1842
// module chunks = 2